import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { AddBankAccountDrawer } from './AddBankAccountDrawer';

export const Route = createFileRoute('/console/$orgId/configuration/financials/bank-account/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add bank account',
        },
        // Only org admins add it (BF-A2); the page's read permission does not open this.
        permissions: ['org:admin'],
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <AddBankAccountDrawer />
        </PageController>
    );
}
